var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Header',{attrs:{"title":"加入博世配件优选店","show-back":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }